// extracted by mini-css-extract-plugin
export default {"container":"GameOver_container__x-xmO","content":"GameOver_content__0UsBR","infobox":"GameOver_infobox__UiUw4","tipLabel":"GameOver_tipLabel__AWDyU"};